import {React} from '../utils/thirdpartyComponents'
const FullLoaderwithText = () => {
  return (
    <div className="cw-loader-overlay align-items-center flex-column justify-content-center">
        <div className="cw-loader"></div>
        <p>Checking bay status</p>
    </div>
  );
};

export default FullLoaderwithText;
